<template>
  <tile class="opc-zmone">
    <foldable v-if="showFoldable" v-model="isExpanded" :title="title" :arrow="canExpand" :edit="canExpand" :isRemoveWrapAriaLabelledby="true">
      <template #head>
        <div class="opc-zm-base-card__head">
        <div class="opc-zm-base-card__head-left">
          <img class="opc-zm-base-card__logo" :src="logo" :alt="title" />
        </div>
        <div class="opc-zm-base-card__head-right">
          <div class="opc-zm-base-card__head-right-content">
            <h2 class="opc-zm-base-card__name text-capitalize">
              {{ title }}
              <!-- <i class="zm-icon-success main-icon" aria-hidden="true"></i> -->
            </h2>
            <div class="opc-zm-base-card__view-detail-button">
              <zm-button data-testid="checkout-button-148" v-if="isExpanded" class="opc-zmone__link" type="link" @click="handleExploreOtherPlansClick">
                {{ $t('billing.zone.explore_other_plans_edit') }}
              </zm-button>
            </div>
          </div>
          <div v-html="getPlanCollapseText()" class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset" v-if="!isExpanded && formPlan">
          </div>
        </div>
      </div>
      </template>
      <div class="opc-zmone__main">
        <zm-form ref="zmoneForm" label-position="top" class="opc-config-form" @submit.prevent>
          <zm-form-item class="opc-zmone__form-item--license">
            <p class="opc-zmone__form-label">
              {{ $t('billing.zone.select_license') }}
              <zm-tooltip class="item" disallow-learn-about aria-label="Learn more about Select the number of users" placement="top">
                <template #content>
                  <span class="opc-zone__tip" v-html="$t('billing.zone.attendee_info_edit')"></span>
                </template>
                <tips-icon aria-label="Learn more about Select the number of users" @click="() => $tracking.buyInteraction(trackingPlanName + ' options', 'number of users - tooltip')" />
              </zm-tooltip>
            </p>
            <license-tip :type="form.category" :number="form.selectedNumber" :visibleForAlertTypes="[ALERT_TYPE.WARNING]">
              <zm-button data-testid="checkout-button-149" class="opc-zmone__link" type="link" v-if="showExploreLink" @click="handleExploreOtherPlansClick">{{
                $t('billing.zone.explore_other_plans') }}</zm-button>
            </license-tip>
            <InputNumberWithPopover class="opc-zmone__quantity-selector" v-model="form.selectedNumber" size="lg"
              controls-position="both" :min="minHost" :max="maxHost" @change="submitLicenseChange"
              :label="`${title} Select the number of users`"
              :data-testid="`checkout-input-license-${formPlan ? formPlan.plan_code : ''}`" />
          </zm-form-item>
          <zm-form-item :label="$t('billing.select_billing_cycle')">
            <zm-radio-group
              v-model="form.billingCycle"
              class="opc-card-radio"
              :aria-label="`${title} Billing Cycle`"
              @change="submitForm"
            >
              <zm-tooltip v-for="plan in currentFilterPlans" :key="plan.billing_cycle"
                :disabled="!billingCycleDisabled(plan.billing_cycle)">
                <template #content>
                  <div v-html="billingCycleDisabled(plan.billing_cycle) || ''" />
                </template>
                <zm-radio :data-testid="`checkout-radio-billing-cycle-${plan.plan_code}`" :label="plan.billing_cycle" :disabled="!!billingCycleDisabled(plan.billing_cycle)"
                  class="opc-zmone__radio">
                  <p class="opc-zmone__radio-title text-capitalize">{{ $t(`billing.billing_cycle.${plan.billing_cycle}`) }}</p>
                  <subscription-cycle-sub-title :billingCycle="plan.billing_cycle" :currentCategory="form.category" />
                  <p class="opc-product-price-container" tabindex="-1" :aria-label="ariaPriceOfMonthForLabel(plan)">
                    <span class="opc-product-price-container__price" aria-hidden="true">
                      {{ getFormattedPriceOfMonth(plan, { forceDiff: true }) }}
                    </span>
                  </p>
                  <p class="opc-zmone__radio-price-unit opc-price-bill-text">
                    <span v-html="getMergedBilledText(plan.billing_cycle, plan.amount)"></span><priceVATTip />
                  </p>
                </zm-radio>
              </zm-tooltip>
            </zm-radio-group>
          </zm-form-item>
          <preview-payment />
        </zm-form>
      </div>
    </foldable>
  </tile>
</template>
<script>
import Foldable from '@/components/foldable.vue';
import Tile from '@/components/tile.vue';
import InputNumberWithPopover from '@/components/input-number/input-number-with-popover';
import logo from '@/assets/plans/icon_ZM.svg';
import {
  A_LINK_TAG_NAME,
  A_LINK_TEXT_CONTENT,
  limitBillingCycleWithBaseZoneTypes,
  BILLING_CYCLE,
  planTypes,
  maxBizAndBizPlusLicenseCount,
  enableProAnnualMonthlyPaymentPlanP2,
  enableProAnnualMonthlyPaymentPlanP3,
  BASE_PLAN_SUB_TYPES,
  ZONE_BASIC_PLUS_CATEGORIES,
} from '@/common/constants';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import FullComparisonDialog from '@/plans/ZOOM_MEETING/dialog/full-comparison-dialog';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { debounce, groupBy, throttle, get } from 'lodash';
import { getCategoryNameI18nKey } from '@/plans/ZOOM_MEETING/common/utils';
import plansMixin from '@/plans/mx/plan';
import { isEmptyVal } from '@/utils';
import LicenseTip from '../license-tip.vue';
import saveMixins from '../save-mixins';
import { getPlanUnitWithCycle } from '@/common/product-unit';
import discountedMonthPrice from '@/common/mixin/discounted-month-price';
import PreviewPayment from '@/views/checkout/payment/preview-payment.vue';
import SubscriptionCycleSubTitle from '@/plans/ZOOM_MEETING/components/subscription-cycle-sub-title.vue';
import { ALERT_TYPE } from '@/common/constants';
import { sortPlansByCycleValue, getPlanCollapseText } from '@/common/product';
import TipsIcon from '@/components/tips-icon/index.vue';

export default {
  mixins: [plansMixin, saveMixins, discountedMonthPrice],
  data() {
    return {
      ALERT_TYPE: Object.freeze(ALERT_TYPE),
      logo,
      isExpanded: true,
      form: {
        category: 'pro',
        billingCycle: 'annual',
        selectedNumber: 1,
      },
      oldPlanCode: '',
      BILLING_CYCLE: BILLING_CYCLE,
      fullComparisonDialog: new ServiceConfirm(FullComparisonDialog, this.$store),
      isInitUpdateForm: false,
      canExpand: true,
      showFoldable: true
    };
  },
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters(['getSelectedPlans', 'getUserCurrentSubscriptions']),
    title() {
      return this.$t(this.formPlan?.planNameKey)
    },
    showExploreLink() {
      return this.form.selectedNumber < maxBizAndBizPlusLicenseCount;
    },
    zonePlans() {
      return this.planMapFlat.filter((item) => item.type === planTypes.ZOOM_MEETING);
    },
    zonePlanGroupByCategory() {
      return groupBy(this.zonePlans, 'category');
    },
    currentFilterPlans() {
      if (
        enableProAnnualMonthlyPaymentPlanP2 &&
        this.form.category === BASE_PLAN_SUB_TYPES.PRO &&
        this.form.billingCycle !== BILLING_CYCLE.ANNUAL_TERM_MONTHLY
      ) {
        if (!enableProAnnualMonthlyPaymentPlanP3) {
          if (ZONE_BASIC_PLUS_CATEGORIES.includes(this.currentEditPlan.category)) {
            return sortPlansByCycleValue(this.currentPlans.filter((item) => item.billing_cycle !== BILLING_CYCLE.ANNUAL_TERM_MONTHLY));
          }
        }
      }
      return sortPlansByCycleValue(this.currentPlans);
    },
    currentPlans() {
      return this.zonePlanGroupByCategory[this.form.category];
    },
    annualPriceM() {
      const monthPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.MONTHLY);
      return monthPlan ? monthPlan.amount * 12 : 0;
    },
    annalPriceSave() {
      const annualPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.ANNUAL);
      if (this.annualPriceM && annualPlan) {
        return this.annualPriceM - annualPlan.amount;
      }
      return 0;
    },
    saveLabel() {
      return {
        [BILLING_CYCLE.MONTHLY]: '',
        [BILLING_CYCLE.ANNUAL]: this.annalPriceSave > 0
          ? `${this.$money(this.annalPriceSave)} ${this.$t('billing.annual_save')}`
          : '',
      };
    },
    // current selected meeting plan
    formPlan() {
      return this.zonePlanGroupByCategory[this.form.category].find(
        (item) => item.billing_cycle === this.form.billingCycle,
      );
    },
    trackingPlanName() {
      return this.$t(`Zoom One ${this.form?.category}`);
    },
    minHost() {
      return this.formPlan ? this.formPlan.min : 1;
    },
    maxHost() {
      return this.formPlan ? this.formPlan.max : 99;
    },
    annualAddonPlans() {
      const newLimit = [];
      return this.getUserCurrentSubscriptions.filter(item => (
        limitBillingCycleWithBaseZoneTypes.concat(newLimit).includes(item.type) &&
        item.billing_cycle === BILLING_CYCLE.ANNUAL
      ));
    },
  },
  created() {
    this.updateForm(true);
  },
  methods: {
    ...mapActions({
      switchSelectPlan: 'switchSelectPlan',
    }),
    ...mapMutations(['updateSelectPlan', 'savePersist', 'setUpdateBasePlan']),
    getPlanCollapseText() {
      return getPlanCollapseText({
        amount: this.formPlan?.amount ?? 0,
        billingCycle: this.form.billingCycle,
        quantity: this.form.selectedNumber,
        cycleValue: this.formPlan?.cycleValue,
        unit: this.formPlan?.unit,
      });
    },
    // sync shopping cart plan to local form state
    updateForm(isInitUpdateForm = false) {
      const shoppingCartPlan = this.getSelectedPlans.find((item) => item.type === planTypes.ZOOM_MEETING);
      if (shoppingCartPlan) {
        this.form.category = shoppingCartPlan.category;
        this.form.billingCycle = shoppingCartPlan.billing_cycle;
        this.form.selectedNumber = shoppingCartPlan.cartInfo.selected_number;
        this.oldPlanCode = shoppingCartPlan.plan_code;
      }

      this.isInitUpdateForm = isInitUpdateForm;
    },
    submitLicenseChange: throttle(function (v) {
      this.$nextTick(() => {
        if (!this.formPlan) {
          return;
        }
        if (isEmptyVal(v)) {
          this.form.selectedNumber = Math.max(this.formPlan?.cartInfo?.selected_number ?? 0, this.minHost);
        }
        this.updateSelectPlan({
          ...this.formPlan,
          cartInfo: {
            selected_number: this.form.selectedNumber,
          },
        });
        this.updateForm();
      });
    }, 500),
    submitForm: throttle(function (v) {
      this.$nextTick(() => {
        if (!this.formPlan) {
          return;
        }

        if (isEmptyVal(v)) {
          this.form.selectedNumber = Math.max(this.formPlan?.cartInfo?.selected_number ?? 0, this.minHost);
        }

        if (this.formPlan.plan_code === this.oldPlanCode) {
          this.updateSelectPlan({
            ...this.formPlan,
            cartInfo: {
              selected_number: this.form.selectedNumber,
            },
          });
        } else {
          this.switchSelectPlan([
            this.oldPlanCode,
            this.formPlan.plan_code,
            {
              selected_number: this.form.selectedNumber,
            },
          ]);
        }
        this.updateForm();
      });
    }, 200),
    async handleExploreOtherPlansClick() {
      this.$tracking.buyInteraction('explore other plans', `${this.trackingPlanName} - explore other plans`);
      await this.showFullComparisonDialog();
    },
    async showFullComparisonDialog() {
      this.$tracking.buyInteraction('product details', 'full plan comparison - impression');
      await this.fullComparisonDialog.confirm();
      this.$nextTick(() => this.updateForm());
    },
    getCategoryName(category) {
      return this.$t(getCategoryNameI18nKey(category));
    },
    onLicenseTipsClick(event) {
      if (event?.target?.tagName === A_LINK_TAG_NAME && event?.target?.textContent === A_LINK_TEXT_CONTENT.FORM) {
        this.$tracking.buyInteraction(
          'banner - product level',
          `${this.trackingPlanName} - 'you are not able to make this change to  your account mid-contract' - contact form`);
        return;
      }
      this.doReturnPlanManagementTracking(event, 'adjust the add-on product and base product license quantity');
    },
    onCycleClick(event) {
      this.doReturnPlanManagementTracking(event, 'update to monthly subscription first');
    },
    doReturnPlanManagementTracking(event, msg) {
      if (event?.target?.tagName === A_LINK_TAG_NAME && event?.target?.textContent === A_LINK_TEXT_CONTENT.RETURN_PLAN_MANAGEMENT) {
        this.$tracking.buyInteraction(
          'banner - product level',
          `${this.trackingPlanName} - ${msg} - return to plan management`);
      }
    },
    getBillingCycleDisabledDesc(billingCycle) {
      if (this.form.billingCycle === billingCycle && billingCycle === BILLING_CYCLE.ANNUAL) {
        return false;
      }
      const planGroupByType = groupBy(this.annualAddonPlans, 'type');
      const typeNames = Object.keys(planGroupByType).map(type => {
        const typeNameKey = get(planGroupByType[type], '0.typeNameKey', '');
        return this.$t(typeNameKey);
      }).filter(Boolean);
      if (billingCycle === BILLING_CYCLE.MONTHLY && this.annualAddonPlans.length) {
        return this.$t('billing.planform.monthly_base_disable_tooltip', [typeNames.join(','), this.$t('billing.planform.title.zoom_meeting_zoomonenew')]);
      }
      return false;
    },
    billingCycleDisabled(billingCycle) {
      return this.getBillingCycleDisabledDesc(billingCycle);
    },
    getPlanUnitWithCycle(cycle) {
      return getPlanUnitWithCycle(cycle);
    },
  },
  components: {
    PreviewPayment,
    Foldable,
    Tile,
    InputNumberWithPopover,
    LicenseTip,
    SubscriptionCycleSubTitle,
    TipsIcon,
  },
  watch: {
    isExpanded: {
      handler(val) {
        this.$tracking.buyInteraction(
          'product details accordion',
          `${this.trackingPlanName} - ${val ? 'expand' : 'collapse'}`,
        );
      },
    },
    'form.billingCycle': {
      immediate: true,
      handler: debounce(function (val) {
        !this.isInitUpdateForm && this.$tracking.buyInteraction(
          'billing cycle',
          `${this.trackingPlanName} - toggled billed ${val}`,
        );
      }, 500),
    },
    'form.selectedNumber': {
      handler: debounce(function (newLicense, oldLicense) {
        if (this.formPlan) {
          // event tracking
          !this.isInitUpdateForm && this.$tracking.buyInteraction('number of hosts',
            `${this.trackingPlanName} - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${newLicense}`);
        }
      }, 500),
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@/styles/zoom-card.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-zmone {
  .main-icon {
    color: $theme-color;
  }

  .reason-tips {
    margin-top: 12px;

    p {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 150%;
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    }
  }

  &__link.zbo-button--text {
    font-weight: 700 !important;
    color: $theme-color;
    padding: 0;
  }

  &__quantity-selector {
    margin-top: 8px;
    @include media(mobile) {
      margin-top: 12px;
    }
  }

  &__desc {
    padding-bottom: 20px;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
  }

  &__main {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #dfdfe4;
    @include media(mobile) {
      margin-top: 16px;
      padding-top: 16px;
    }
  }

  &__desc {
    position: relative;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    color: var(--zoom-color-text-strong-neutral, #555B62);
    padding: 0;
    margin: 0;
    @include media(mobile) {
      font-size: 14px;
    }

    &.is-warning {
      padding: 8px 12px 8px 40px;
      background: var(--zoom-color-fill-subtler-warning, #FFF9F2);
      border-radius: 8px;

      &::before {
        content: '';
        background-image: url('../../../assets/Alert.svg');
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        top: calc(50% - 8px);
        left: 12px;
      }
    }
  }

  &__form-label {
    margin: 0;
    padding: 0;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 16px;
    font-weight: 600;
    line-height: 20px; /* 125% */
    letter-spacing: -0.31px;
    @include media(mobile) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  .opc-card-radio {
    margin-top: 8px;

    .opc-zmone__radio {
      .zbo-radio__wrap {
        width: 100%;
      }
    }
  }

  .opc-card-radio &__radio {
    .zbo-radio__label--inner {
      width: 100%;
      // min-height: 136px;
      padding: 16px;
    }

    &-title {
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;

      .opc-price-save-count {
        margin-left: 4px;
      }
    }

    .zbo-radio__label {
      &.is-disabled {
        .opc-zmone__radio-title, .opc-zmone__radio-price, .opc-zmone__radio-price-unit {
          color: var(--zoom-color-state-disable, #ADB1B8) !important;
        }
      }
    }

    &-save-label {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 21px;
      color: var(--zoom-color-text-success, #247F40);
      min-width: 1px;
      min-height: 21px;
    }

    &-price {
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: 33px;

      &-unit {
        color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
      }

      &-delete {
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
        text-decoration-line: line-through;
        color: var(--zoom-color-text-strong-neutral, #555B62);
      }
    }
  }
}

.opc-zmone {
  .opc-config-form {
    .opc-zmone__form-item--license {
      .zbo-form-item__row {
        .zbo-form-item__label-wrapper {
          height: 0px;
        }
      }
    }
  }
}
</style>

<style lang="scss">.opc-zone__tip b {
  font-weight: bold !important;
}</style>
